<template >
  <dev class="footer-container">
    <router-link class="navbar-brand" active-class="selected" to="/impress">
      Impressum
    </router-link>
    <router-link class="navbar-brand" active-class="selected" to="/privacy">
      Datenschutzerklärung
    </router-link>
  </dev>
</template>

<script>
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

export default {
  props: {
    title: String,
    items: Array
  },
  components: {
  },
  data() {
    return {
      offcanvas: null
    };
  },
  mounted() {
    // Greife auf das DOM-Element zu, wenn die Komponente gemountet ist
    this.offcanvas = new bootstrap.Offcanvas(document.getElementById("offcanvasDarkNavbar"));
  },
  methods: {
    closeOffcanvas() {
      if (this.offcanvas) {
        this.offcanvas.hide();
      }
    }
  }
};
</script>

<style scoped>
.footer-container{
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:15px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color:white;
  background-color: rgb(33, 37, 41) !important;
}
</style>